import { UserType } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { ADMIN_BASE_URL, AGENT_BASE_URL } from "../../constants";
import { useRequest } from "../../utils/request";
import { SuretyAccountPreview } from "../account/agent/types";
import { accountPreviewsQueryKey } from "./previews.keys";

export const useFetchAccountPreviews = () => {
	const { user } = useAuthenticatedUser();
	const { get } = useRequest();

	const baseUrl = user.type === UserType.admin ? ADMIN_BASE_URL : AGENT_BASE_URL;

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountPreviewsQueryKey(),
		queryFn: async () => await get<SuretyAccountPreview[]>(baseUrl + "/surety/accounts/previews"),
	});

	return {
		accountPreviews: data,
		accountPreviewsError: error,
		accountPreviewsIsLoading: isLoading,
		refetchAccountPreviews: refetch,
	};
};
